import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../theme';
import { useStore } from '../store';
import { notifications as notifApi, earns as earnsApi, homeTiles as tilesApi } from '../services/api';
import { useStatusBar } from './SharedComponents';
import toast from 'react-hot-toast';
import { ALL_SECTIONS } from '../config/tiles';



function QIcon({ type, color }) {
  const s = { width:22, height:22, stroke:color, strokeWidth:2.2, fill:'none', strokeLinecap:'round', strokeLinejoin:'round' };
  if (type==='pay') return (
    <svg viewBox="0 0 24 24" style={s}><rect x="2" y="5" width="20" height="14" rx="3"/><path d="M2 10h20"/><path d="M6 15h4"/></svg>
  );
  if (type==='buy') return (
    <svg viewBox="0 0 24 24" style={s}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
  );
  if (type==='sell') return (
    <svg viewBox="0 0 24 24" style={s}><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/></svg>
  );
  if (type==='orders') return (
    <svg viewBox="0 0 24 24" style={s}><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
  );
  return null;
}

function SduiBlock({ block, nav, C }) {
  const content = block.content || {};
  const LeftIcon = () => {
    if (content.image) return (
      <img src={content.image} alt={block.title||''} style={{height:38,width:'auto',maxWidth:120,objectFit:'contain',flexShrink:0}}/>
    );
    if (content.icon) return <div style={{fontSize:28,flexShrink:0}}>{content.icon}</div>;
    return null;
  };
  if (block.type==='banner') {
    if (content.fullImage) return (
      <div onClick={()=>content.path&&nav(content.path)} style={{
        margin:'12px 16px 0',borderRadius:16,overflow:'hidden',
        cursor:'pointer',position:'relative',
        boxShadow:'0 4px 20px rgba(0,0,0,0.25)',
      }}>
        <img src={content.image} alt={block.title||''}
          style={{width:'100%',height:content.height||140,objectFit:'cover',objectPosition:content.objectPosition||'center',display:'block'}}/>
        {content.cta&&<div style={{
          position:'absolute',bottom:14,right:14,
          background:'rgba(10,22,40,0.7)',
          border:'1px solid rgba(245,158,11,0.6)',
          borderRadius:20,padding:'6px 14px',
          color:'#f59e0b',fontSize:11,fontWeight:700,
          letterSpacing:0.3,
        }}>{content.cta} →</div>}
      </div>
    );
    return (
      <div onClick={()=>content.path&&nav(content.path)} style={{
        margin:'12px 16px 0',
        background:content.bg||'linear-gradient(135deg,#1a3cc8,#7c3aed)',
        borderRadius:16,padding:'14px 16px',cursor:content.path?'pointer':'default',
        boxShadow:'0 3px 12px rgba(0,0,0,0.15)',
      }}>
        <div style={{display:'flex',alignItems:'center',gap:12}}>
          <LeftIcon/>
          <div style={{flex:1}}>
            {block.title&&<div style={{fontSize:11,fontWeight:800,color:'#fff',marginBottom:2}}>{block.title}</div>}
            {content.text&&<div style={{fontSize:11,color:'rgba(255,255,255,0.8)',lineHeight:1.4}}>{content.text}</div>}
          </div>
          {content.cta&&<div style={{background:'rgba(255,255,255,0.95)',borderRadius:8,
            padding:'6px 12px',color:'#1a1a2e',fontSize:11,fontWeight:700,flexShrink:0}}>{content.cta} →</div>}
        </div>
      </div>
    );
  }
  if (block.type==='card') return (
    <div onClick={()=>content.path&&nav(content.path)} style={{
      margin:'12px 16px 0',background:content.bg||C.card,
      borderRadius:16,padding:'14px 16px',cursor:content.path?'pointer':'default',
      border:content.bg?'none':'1px solid '+C.border,boxShadow:C.shadow,
    }}>
      <div style={{display:'flex',alignItems:'center',gap:12}}>
        <LeftIcon/>
        <div style={{flex:1}}>
          {block.title&&<div style={{fontSize:13,fontWeight:800,color:content.bg?'#fff':C.text,marginBottom:2}}>{block.title}</div>}
          {block.subtitle&&<div style={{fontSize:11,color:content.bg?'rgba(255,255,255,0.75)':C.muted}}>{block.subtitle}</div>}
        </div>
        {content.cta&&<div style={{background:content.bg?'rgba(255,255,255,0.95)':'#1a3cc8',
          borderRadius:8,padding:'6px 12px',color:content.bg?'#1a1a2e':'#fff',fontSize:11,fontWeight:700,flexShrink:0}}>{content.cta} →</div>}
      </div>
    </div>
  );
  return null;
}

const FIXED_QUICK = [];

export default function HomeScreen() {
  const C = useTheme();
  const nav = useNavigate();
  useStatusBar('#ffffff');
  const {user} = useStore();
  const [txcPrice, setTxcPrice] = useState(null);
  const [pocketBalance, setPocketBalance] = useState(0);
  const [spendingBalance, setSpendingBalance] = useState(0);
  const [userTier, setUserTier] = useState('Explorer');
  useEffect(() => {
    // Fetch TXC price
    fetch('/api/exchanger/txc/price')
      .then(r=>r.json()).then(setTxcPrice).catch(()=>{});
    // Fetch pocket balance
    const token = localStorage.getItem('nexus_token');
    if(token) {
      fetch('/api/backend/v1/pocket', {headers:{Authorization:'Bearer '+token}})
        .then(r=>r.json()).then(d=>setPocketBalance(d.txc_balance||0)).catch(()=>{});
      fetch('/api/backend/v1/wallet', {headers:{Authorization:'Bearer '+token}})
        .then(r=>r.json()).then(d=>setSpendingBalance(d.txc_balance||0)).catch(()=>{});
      fetch('/api/backend/v1/earns/summary', {headers:{Authorization:'Bearer '+token}})
        .then(r=>r.json()).then(d=>setUserTier(d.tier?.name||'Explorer')).catch(()=>{});
    }
  }, [user?.id]);

  const rawName = user?.full_name || user?.username || user?.email?.split('@')[0] || 'User';
  const name = rawName.charAt(0).toUpperCase() + rawName.slice(1).split(' ')[0]; // First name only
  const greeting = (() => {
    const h = new Date().getHours();
    if(h >= 5  && h < 12) return { text: 'Good morning',  emoji: '☀️' };
    if(h >= 12 && h < 17) return { text: 'Good afternoon', emoji: '🌤️' };
    if(h >= 17 && h < 21) return { text: 'Good evening',  emoji: '🌙' };
    return { text: 'Hey night owl', emoji: '🦉' };
  })();
  const [scoreData, setScoreData] = useState(null);
  // Default sections from ALL_SECTIONS tiles config
  const DEFAULT_SECTIONS = ALL_SECTIONS.flatMap(s=>s.tiles).slice(0,20);
  const [mySections, setMySections] = useState(DEFAULT_SECTIONS);
  const [unread, setUnread] = useState(0);
  const [sectionLayout, setSectionLayout] = useState(()=>{
    return parseInt(localStorage.getItem('vgo_section_layout')||'1',10);
  });
  const [sduiBlocks, setSduiBlocks] = useState([]);

  useEffect(()=>{
    earnsApi.summary().then(r=>setScoreData(r)).catch(()=>{});
    notifApi.unreadCount().then(r=>setUnread(r.count||0)).catch(()=>{});
    // Fetch SDUI content blocks
    fetch('/api/backend/v1/home/blocks',{
      headers:{Authorization:`Bearer ${localStorage.getItem('nexus_token')}`}
    }).then(r=>r.json()).then(d=>setSduiBlocks(d.blocks||[])).catch(()=>{});
    // Load from backend first, fallback to localStorage
    tilesApi.get().then(r=>{
      if(!r.is_default && r.tiles && r.tiles.length>0){
        const sections = r.tiles.map(t=>({
          id: t.tile_id, icon: t.tile_icon||'⭐',
          label: t.tile_label, color: t.tile_color||'#534AB7',
          path: t.tile_path||'/home', desc: t.tile_desc||'',
          isBusiness: t.is_business||false,
        }));
        setMySections(sections);
        localStorage.setItem('vgo_my_sections', JSON.stringify(sections));
      } else {
        const saved = localStorage.getItem('vgo_my_sections');
        if(saved){ try{setMySections(JSON.parse(saved));}catch(e){} }
        // else keep DEFAULT_SECTIONS
      }
    }).catch(()=>{
      const saved = localStorage.getItem('vgo_my_sections');
      if(saved){ try{setMySections(JSON.parse(saved));}catch(e){} }
      // else keep DEFAULT_SECTIONS
    });
  },[]);

  useEffect(()=>{
    const section = sessionStorage.getItem('home_section');
    if(section){ sessionStorage.removeItem('home_section'); setTimeout(()=>{ const el=document.getElementById(section); if(el)el.scrollIntoView({behavior:'instant',block:'start'}); },200); }
  },[]);

  const removeSection = (id) => {
    const updated = mySections.filter(s=>s.id!==id);
    setMySections(updated);
    localStorage.setItem('vgo_my_sections', JSON.stringify(updated));
    // Save to backend
    tilesApi.save({tiles: updated.map((s,i)=>({
      tile_id: s.id, tile_label: s.label, tile_icon: s.icon,
      tile_path: s.path, tile_color: s.color, tile_desc: s.desc,
      is_business: s.isBusiness||false, sort_order: i,
    }))}).catch(()=>{});
    toast.success('Section removed');
  };

  const HERO_TILES = [
    {id:'food',    label:'Food',          icon:'🍽️', color:'#f97316', path:'/browse/mod_food_delivery'},
    {id:'grocery', label:'Grocery',       icon:'🛒', color:'#10b981', path:'/browse/mod_grocery'},
    {id:'shop',    label:'Shop',          icon:'🛍️', color:'#7c3aed', path:'/browse/mod_shop'},
    {id:'orders',  label:'Order History', icon:'📦', color:'#1a3cc8', path:'/order-history'},
  ];
  const SCROLL_TILES = [
    {id:'lab',     label:'Lab Tests',   icon:'🧪', color:'#7c3aed', path:'/browse/mod_lab'},
    {id:'repair',  label:'Repairs',     icon:'🔧', color:'#64748b', path:'/browse/mod_repairs'},
    {id:'cab',     label:'Cab',         icon:'🚖', color:'#f59e0b', path:'/browse/mod_cab'},
    {id:'cleaning',label:'Cleaning',    icon:'🧹', color:'#06b6d4', path:'/browse/mod_cleaning'},
    {id:'pharmacy',label:'Pharmacy',    icon:'💊', color:'#0ea5e9', path:'/browse/mod_pharmacy'},
    {id:'hotel',   label:'Hotels',      icon:'🏨', color:'#7c3aed', path:'/browse/mod_hotels'},
    {id:'fashion', label:'Fashion',     icon:'👗', color:'#ec4899', path:'/browse/mod_fashion'},
    {id:'fitness', label:'Fitness',     icon:'💪', color:'#f97316', path:'/browse/mod_fitness'},
    {id:'meetup',  label:'Meetup',      icon:'🤝', color:'#1a3cc8', path:'/meetup'},
    {id:'more',    label:'All Services',icon:'⚡', color:'#1a3cc8', path:'/explore-sections'},
  ];

  return (
    <div style={{maxWidth:430,margin:'0 auto',background:C.bg,minHeight:'100vh',paddingBottom:80}}>

      {/* ── STICKY GREETING ── */}
      <div style={{position:'sticky',top:0,zIndex:100,background:'#1a3cc8',
        padding:'20px 16px 12px'}}>
        {/* Greeting row */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:20}}>
          <div>
            <div style={{fontSize:12,color:'rgba(255,255,255,0.65)',marginBottom:3}}>
              {greeting.text} {greeting.emoji}
            </div>
            <div style={{fontSize:24,fontWeight:900,color:'#fff',letterSpacing:-0.5}}>{name}</div>
            {scoreData && (
              <div onClick={()=>nav('/my-earns')} style={{
                marginTop:7,display:'inline-flex',alignItems:'center',gap:5,cursor:'pointer',
                background:'rgba(255,255,255,0.15)',borderRadius:20,padding:'3px 10px 3px 6px'
              }}>
                <div style={{width:18,height:18,borderRadius:'50%',background:'#fbbf24',
                  display:'flex',alignItems:'center',justifyContent:'center',
                  fontSize:10,fontWeight:800,color:'#92400e'}}>
                  {scoreData.current_tier_icon||'🥉'}
                </div>
                <span style={{fontSize:11,color:'rgba(255,255,255,0.9)',fontWeight:600}}>
                  {scoreData.current_tier||'Explorer'} · {scoreData.current_score||0} pts
                </span>
              </div>
            )}
          </div>
             <div style={{display:'flex',gap:8,alignItems:'center'}}>
            <div onClick={()=>nav('/notifications')} style={{position:'relative',
              background:'rgba(255,255,255,0.15)',borderRadius:10,width:38,height:38,
              display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}>
              <span style={{fontSize:18}}>🔔</span>
              {unread>0&&<div style={{position:'absolute',top:-4,right:-4,width:17,height:17,
                borderRadius:'50%',background:'#ef4444',fontSize:9,fontWeight:700,color:'#fff',
                display:'flex',alignItems:'center',justifyContent:'center'}}>{unread}</div>}
            </div>
            <div onClick={()=>nav('/profile')} style={{background:'rgba(255,255,255,0.25)',
              borderRadius:10,width:38,height:38,display:'flex',alignItems:'center',
              justifyContent:'center',fontSize:15,fontWeight:800,color:'#fff',cursor:'pointer'}}>
              {(name[0]||'U').toUpperCase()}
            </div>
          </div>
        </div>

      </div>{/* end sticky greeting */}

      {/* ── WALLET CARD ── */}
      <div style={{background:'#1a3cc8',padding:'0 16px 24px'}}>
        <div onClick={()=>nav('/wallet')} style={{
          background:'rgba(255,255,255,0.12)',borderRadius:18,
          padding:'14px 16px',cursor:'pointer'}}>
          <div style={{display:'flex',justifyContent:'space-between',
            alignItems:'flex-start',marginBottom:12}}>
            <div>
              <div style={{fontSize:11,color:'rgba(255,255,255,0.6)',marginBottom:4}}>
                Spending Wallet
              </div>
              <div style={{fontSize:28,fontWeight:900,color:'#fff',
                letterSpacing:-1,lineHeight:1}}>
                {spendingBalance.toLocaleString('en-IN')}
                <span style={{fontSize:14,fontWeight:600,opacity:0.7,marginLeft:4}}>TXC</span>
              </div>
            </div>
            <div style={{textAlign:'right'}}>
              <div style={{fontSize:11,color:'rgba(255,255,255,0.6)',marginBottom:4}}>
                Rewards
              </div>
              <div style={{fontSize:20,fontWeight:700,color:'#fff',lineHeight:1}}>
                {pocketBalance.toFixed(0)}
                <span style={{fontSize:12,opacity:0.7,marginLeft:3}}>TXC</span>
              </div>
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',
            borderTop:'1px solid rgba(255,255,255,0.1)',paddingTop:10}}>
            <div onClick={e=>{e.stopPropagation();nav('/vanta');}}
              style={{display:'flex',alignItems:'center',gap:6,cursor:'pointer'}}>
              <span style={{fontSize:14}}>◈</span>
              <span style={{fontSize:11,color:'rgba(255,255,255,0.75)'}}>Ask VANTA AI</span>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:14}}>
              <div style={{textAlign:'right'}}>
                <div style={{fontSize:10,color:'rgba(255,255,255,0.55)'}}>TXC Price</div>
                <div style={{fontSize:12,fontWeight:700,color:'#4ade80'}}>
                  {txcPrice?`₹${parseFloat(txcPrice.price_inr).toFixed(2)}`:'₹—'} ↑
                </div>
              </div>
              <div onClick={e=>{e.stopPropagation();nav('/vanta');}} style={{background:'rgba(255,255,255,0.2)',borderRadius:8,
                padding:'5px 12px',cursor:'pointer'}}>
                <span style={{fontSize:11,color:'#fff',fontWeight:600}}>Chat →</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── QUICK SERVICES ── */}
      <div style={{background:C.bg,padding:'18px 16px 14px'}}>
        <div style={{fontSize:13,fontWeight:800,color:C.text,marginBottom:14}}>
          Services
        </div>
        {/* ── 4 Hero Tiles 2x2 ── */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:16}}>
          {HERO_TILES.map(s=>(
            <div key={s.id} onClick={()=>nav(s.path)}
              style={{background:C.card,borderRadius:16,
                padding:'14px 8px',cursor:'pointer',
                display:'flex',flexDirection:'column',
                alignItems:'center',gap:8,
                boxShadow:'0 2px 8px rgba(0,0,0,0.06)',
                border:'1px solid '+C.border}}>
              <div style={{width:46,height:46,borderRadius:14,
                background:s.color+'18',
                display:'flex',alignItems:'center',justifyContent:'center',
                fontSize:24}}>
                {s.icon}
              </div>
              <div style={{fontSize:11,fontWeight:700,color:C.text,
                textAlign:'center',lineHeight:1.3}}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* ── MY HOME ── */}
      <div style={{padding:'0 16px 24px'}}>
        <div style={{display:'flex',justifyContent:'space-between',
          alignItems:'center',marginBottom:12}}>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            <div style={{width:3,height:18,background:'#1a3cc8',borderRadius:2}}/>
            <span style={{fontSize:14,fontWeight:800,color:C.text}}>My Home</span>
          </div>
          <div style={{display:'flex',gap:5}}>
            {[{n:1,icon:'☰'},{n:2,icon:'⊞'},{n:3,icon:'⊟'}].map(opt=>(
              <button key={opt.n} onClick={()=>{
                setSectionLayout(opt.n);
                localStorage.setItem('vgo_section_layout',String(opt.n));
              }} style={{
                width:28,height:28,borderRadius:8,border:'1px solid '+C.border,
                background:sectionLayout===opt.n?'#1a3cc8':C.card,
                color:sectionLayout===opt.n?'#fff':C.muted,
                cursor:'pointer',fontSize:13,
                display:'flex',alignItems:'center',justifyContent:'center',
              }}>{opt.icon}</button>
            ))}
          </div>
        </div>

        {mySections.length===0 && (
          <div style={{background:C.card,border:'1px solid '+C.border,
            borderRadius:16,padding:'24px 20px',marginBottom:8,
            display:'flex',flexDirection:'column',alignItems:'center',
            textAlign:'center',gap:8}}>
            <div style={{width:56,height:56,borderRadius:16,background:'#1a3cc812',
              display:'flex',alignItems:'center',justifyContent:'center',
              fontSize:28,marginBottom:4}}>🏠</div>
            <div style={{fontSize:14,fontWeight:800,color:C.text}}>Build your home screen</div>
            <div style={{fontSize:12,color:C.muted,lineHeight:1.6,maxWidth:240}}>
              Pin services you use most for one-tap access
            </div>
            <button onClick={()=>nav('/explore-sections')} style={{
              marginTop:6,background:'#1a3cc8',border:'none',
              borderRadius:10,padding:'9px 20px',
              color:'#fff',fontSize:12,fontWeight:700,cursor:'pointer',
            }}>Browse 99+ services →</button>
          </div>
        )}

        <div key={sectionLayout} style={{
          display:sectionLayout===1?'block':'grid',
          gridTemplateColumns:sectionLayout===2?'repeat(2,1fr)':sectionLayout===3?'repeat(3,1fr)':undefined,
          gap:sectionLayout>1?10:0,
        }}>
          {mySections.map(section=>(
            sectionLayout===1 ? (
              <div key={section.id} onClick={()=>nav(section.path)} style={{
                background:C.card,
                border:section.isBusiness?`2px solid ${section.color}44`:'1px solid '+C.border,
                borderRadius:14,padding:'12px 14px',marginBottom:8,
                display:'flex',alignItems:'center',gap:12,cursor:'pointer',
              }}>
                <div style={{width:44,height:44,borderRadius:13,flexShrink:0,
                  background:(section.color||'#1a3cc8')+'18',
                  display:'flex',alignItems:'center',justifyContent:'center',fontSize:22}}>
                  {section.icon}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:'flex',alignItems:'center',gap:6}}>
                    <div style={{fontSize:13,fontWeight:700,color:C.text}}>{section.label}</div>
                    {section.isBusiness&&<div style={{fontSize:9,fontWeight:700,
                      color:'#fff',background:'#1a3cc8',borderRadius:4,
                      padding:'1px 5px'}}>BIZ</div>}
                  </div>
                  {section.desc&&section.desc!==section.label&&(
                    <div style={{fontSize:11,color:C.muted,marginTop:1}}>{section.desc}</div>
                  )}
                </div>
                <div style={{display:'flex',alignItems:'center',gap:6}}>
                  <button onClick={e=>{e.stopPropagation();removeSection(section.id);}}
                    style={{width:22,height:22,borderRadius:'50%',
                      background:'#ef444415',border:'none',color:'#ef4444',
                      fontSize:13,cursor:'pointer',display:'flex',
                      alignItems:'center',justifyContent:'center'}}>×</button>
                  <div style={{fontSize:16,color:C.muted}}>›</div>
                </div>
              </div>
            ) : sectionLayout===2 ? (
              <div key={section.id} onClick={()=>nav(section.path)} style={{
                background:C.card,border:'1px solid '+C.border,
                borderRadius:14,padding:'12px',cursor:'pointer',
                position:'relative',display:'flex',alignItems:'center',gap:10,
              }}>
                <button onClick={e=>{e.stopPropagation();removeSection(section.id);}}
                  style={{position:'absolute',top:-5,right:-5,width:16,height:16,
                    borderRadius:'50%',background:'#ef4444',border:'2px solid '+C.bg,
                    color:'#fff',fontSize:9,cursor:'pointer',
                    display:'flex',alignItems:'center',justifyContent:'center',zIndex:2}}>×</button>
                <div style={{width:36,height:36,borderRadius:10,flexShrink:0,
                  background:(section.color||'#1a3cc8')+'18',
                  display:'flex',alignItems:'center',justifyContent:'center',fontSize:18}}>
                  {section.icon}
                </div>
                <div style={{flex:1,minWidth:0,overflow:'hidden'}}>
                  <div style={{fontSize:11,fontWeight:700,color:C.text,
                    overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                    {section.label}
                  </div>
                </div>
              </div>
            ) : (
              <div key={section.id} onClick={()=>nav(section.path)} style={{
                background:C.card,border:'1px solid '+C.border,
                borderRadius:12,padding:'10px 6px',cursor:'pointer',
                display:'flex',flexDirection:'column',alignItems:'center',
                gap:5,position:'relative',
              }}>
                <button onClick={e=>{e.stopPropagation();removeSection(section.id);}}
                  style={{position:'absolute',top:-5,right:-5,width:15,height:15,
                    borderRadius:'50%',background:'#ef4444',border:'2px solid '+C.bg,
                    color:'#fff',fontSize:8,cursor:'pointer',
                    display:'flex',alignItems:'center',justifyContent:'center',zIndex:2}}>×</button>
                <div style={{width:32,height:32,borderRadius:10,
                  background:(section.color||'#1a3cc8')+'18',
                  display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>
                  {section.icon}
                </div>
                <div style={{fontSize:9,fontWeight:700,color:C.text,
                  textAlign:'center',lineHeight:1.2}}>{section.label}</div>
              </div>
            )
          ))}
        </div>

        {/* Add to My Home */}
        <div onClick={()=>nav('/explore-sections')} style={{
          background:C.card,border:'1.5px dashed #c7d2fe',
          borderRadius:14,padding:'12px 14px',
          marginTop:mySections.length>0?8:0,
          display:'flex',alignItems:'center',gap:12,cursor:'pointer',
        }}>
          <div style={{width:44,height:44,borderRadius:13,background:'#eef2ff',
            display:'flex',alignItems:'center',justifyContent:'center',
            fontSize:22,flexShrink:0}}>＋</div>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:700,color:'#6366f1'}}>Add to My Home</div>
            <div style={{fontSize:11,color:'#a5b4fc',marginTop:2}}>
              Browse VGO Store to add sections
            </div>
          </div>
          <div style={{fontSize:16,color:'#c7d2fe'}}>›</div>
        </div>
      </div>

      {/* ── SDUI BLOCKS ── */}
      {sduiBlocks.map((block,i)=>(
        <SduiBlock key={block.id||i} block={block} nav={nav} C={C}/>
      ))}

      <div style={{height:24}}/>
    </div>
  );
}
